var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"hide-on-print",attrs:{"id":"footer"}},[_c('b-container',[_c('div',{staticClass:"row row-centered-v"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.year)+" ® "+_vm._s(_vm.uiGetTheme.footerText)+" ")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }